// import React, { useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import config from '../config';

// const server_URL = config.SERVER_URL;

// const Tracker = () => {
//   const { uid } = useParams();
//   console.log(uid)
//   const handlePage = async () => {
//     try {
//       const response = await fetch(`${server_URL}/api/tracker`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ 'uid':uid}),
//       });

//       const data = await response.json();

//       if (data.status == '1') {
//         return ''
//         img = 'px1.png'
//         // openWebsite(data.url);
//       }
//     } catch (error) {
//     //   console.error('Error:', error);
//     }
//   };

  
//   useEffect(() => {
//     handlePage();
//   }, []);

  
//   return ('');
// };

// export default Tracker; 


// import React, { useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import config from '../config';

// const server_URL = config.SERVER_URL;

// const Tracker = () => {
//   const { uid } = useParams();
  
//   const handleTracking = async () => {
//     try {
//       const response = await fetch(`${server_URL}/api/tracker`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ uid: uid }),
//       });

//       const data = await response.json();
      
//       if (data.status === '1') {
//         console.log('Tracking recorded successfully');
//       }
//     } catch (error) {
//       console.error('Tracking error:', error);
//     }
//   };

//   useEffect(() => {
//     handleTracking();
//   }, [uid]);

//   // Return a hidden 1x1 transparent GIF
//   return (
//     <div style={{ 
//       position: 'absolute',
//       top: 0,
//       left: 0,
//       width: '1px',
//       height: '1px',
//       overflow: 'hidden',
//       opacity: 0
//     }}>
//       <img 
//         src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" 
//         alt="" 
//         width="1" 
//         height="1" 
//         style={{ 
//           border: 'none',
//           display: 'block'
//         }}
//         onLoad={() => console.log('Tracker image loaded')}
//       />
//     </div>
//   );
// };

// export default Tracker;


import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import config from '../config';

const server_URL = config.SERVER_URL;

const Tracker = () => {
  const { uid} = useParams();

  useEffect(() => {
    const trackAndLoadImage = async () => {
      try {
        
        const response = await fetch(`${server_URL}/api/tracker`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ 'uid': uid }),
        });

        if (response.ok) {
          // Create blob URL from the image response
          const blob = await response.blob();
          const imageUrl = URL.createObjectURL(blob);
          
          // Create and append image to DOM
          const img = document.createElement('img');
          img.src = imageUrl;
          img.style.display = 'none'; // Hide the image
          document.body.appendChild(img);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    };

    trackAndLoadImage();
  }, [uid]);

  // Return minimal content
  return (
    <div style={{ width: '1px', height: '1px', overflow: 'hidden' }}>
      Tracking...
    </div>
  );
};

export default Tracker;